import { render, staticRenderFns } from "./rewardSerialPackEdit_bak.vue?vue&type=template&id=5a5db21e&scoped=true&"
import script from "./rewardSerialPackEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardSerialPackEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5db21e",
  null
  
)

export default component.exports